// FE-SCRM-055 — Sales Settings types.

export interface TagInventoryRow {
  tag: string;
  count: number;
}

export interface TagInventoryResponse {
  prospect: TagInventoryRow[];
  opportunity: TagInventoryRow[];
  contact: TagInventoryRow[];
}

export type TagEntityType = "prospect" | "opportunity" | "contact";


// FE-SCRM-055 — per-user UI preferences. Stored in localStorage
// (key: ``salesCrmUserPrefs``) because v1 doesn't have a UserPref
// table and these knobs only affect the rendering of one user's
// browser. When the table ships, the storage adapter is the only
// thing that has to change.
export interface SalesCrmUserPreferences {
  renewal_board_geometry: "grid" | "timeline";
  default_landing_tab:
    | "pipeline" | "prospects" | "activities" | "reports" | "settings";
  default_activities_sort: "due_at_asc" | "due_at_desc" | "created_desc";
}


export const DEFAULT_USER_PREFS: SalesCrmUserPreferences = {
  renewal_board_geometry: "grid",
  default_landing_tab: "pipeline",
  default_activities_sort: "due_at_asc",
};
